import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/Subtopic2/Llenado_maquina_cafe.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";

export class CoffeeMachineFilling extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(0.2, -0.4017, 4.5803);
		this.rotation.set(1.0332, 0, 0.18);
		this.scale.set(2, 2, 2);
		this.observerListtneners();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Garrafon = gltf.scene.getObjectByName("Garrafon", true);
			this.Americano = gltf.scene.getObjectByName("Americano", true);
			this.Capuchino = gltf.scene.getObjectByName("Capuchino", true);
			this.Kobalto = gltf.scene.getObjectByName("Kobalto", true);
		});
	}

	observerListtneners() { }

	hiddemObjects() {
		this.Garrafon.visible = false;
		this.Americano.visible = false;
		this.Capuchino.visible = false;
		this.Kobalto.visible = false;
		// this.helpers();
	}

	onVisibleCoffes() {
		this.Americano.visible = true;
		this.Americano.position.set(19.624, -13.6755, 0);
		this.Americano.rotation.set(0, 0, 2.2476);
		this.Capuchino.visible = true;
		this.Capuchino.position.set(-1.9227, -10.0377, 0);
		this.Capuchino.rotation.set(0, 0, 2.4575);
		this.Kobalto.visible = true;
		this.Kobalto.position.set(-21, -9.1982, 0);
		this.Kobalto.rotation.set(0, 0, 2.8073);
	}

	onMoveObjectTable() {
		this.position.set(-12.1356, -0.847, 2.8303);
		this.rotation.set(0, 0, 0);
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null

			this.Americano.material.emissiveIntensity = 1
			this.Capuchino.material.emissiveIntensity = 1
			this.Kobalto.material.emissiveIntensity = 1
		}
	}

	onAnimate(object, previousObject) {
		if (this.animation) {
			this.animation.kill();
		}

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.Americano.material.emissiveIntensity = 1;
		this.Capuchino.material.emissiveIntensity = 1;
		this.Kobalto.material.emissiveIntensity = 1;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const { position: positionAmericano, rotation: rotationAmericano } = this.Americano;
		const folferAmericano = gui.addFolder("Americano");
		folferAmericano.add(positionAmericano, "x", -20, 20).step(0.0001).name("Posición A X");
		folferAmericano.add(positionAmericano, "y", -20, 20).step(0.0001).name("Posición A Y");
		folferAmericano.add(positionAmericano, "z", -20, 20).step(0.0001).name("Posición A Z");
		folferAmericano.add(rotationAmericano, "x", -5, 5).step(0.0001).name("rotation A X");
		folferAmericano.add(rotationAmericano, "y", -5, 5).step(0.0001).name("rotation A Y");
		folferAmericano.add(rotationAmericano, "z", -5, 5).step(0.0001).name("rotation A Z");
		const { position: positionCapuchino, rotation: rotationCapuchino } = this.Capuchino;
		const folferCapuchino = gui.addFolder("Capuchino");
		folferCapuchino.add(positionCapuchino, "x", -20, 20).step(0.0001).name("Posición A X");
		folferCapuchino.add(positionCapuchino, "y", -20, 20).step(0.0001).name("Posición A Y");
		folferCapuchino.add(positionCapuchino, "z", -20, 20).step(0.0001).name("Posición A Z");
		folferCapuchino.add(rotationCapuchino, "x", -5, 5).step(0.0001).name("rotation A X");
		folferCapuchino.add(rotationCapuchino, "y", -5, 5).step(0.0001).name("rotation A Y");
		folferCapuchino.add(rotationCapuchino, "z", -5, 5).step(0.0001).name("rotation A Z");
		const { position: positionKobalto, rotation: rotationKobalto } = this.Kobalto;
		const folferKobalto = gui.addFolder("Kobalto");
		folferKobalto.add(positionKobalto, "x", -20, 20).step(0.0001).name("Posición A X");
		folferKobalto.add(positionKobalto, "y", -20, 20).step(0.0001).name("Posición A Y");
		folferKobalto.add(positionKobalto, "z", -20, 20).step(0.0001).name("Posición A Z");
		folferKobalto.add(rotationKobalto, "x", -5, 5).step(0.0001).name("rotation A X");
		folferKobalto.add(rotationKobalto, "y", -5, 5).step(0.0001).name("rotation A Y");
		folferKobalto.add(rotationKobalto, "z", -5, 5).step(0.0001).name("rotation A Z");

		const premiaFolder = gui.addFolder("cupCoffe");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	renderAnimations() { }
}
